module.exports = __webpack_public_path__ + "static/media/deal-new-product.37cfcca3.png";